import React from "react";
import LoadingContainer from "../containers/LoadingContainer";

const LoadingPage = () => {
  window.history.pushState(null, null, window.location.href);
  return <LoadingContainer></LoadingContainer>;
};

export default LoadingPage;
